import { FORM_VALIDATOR_TYPES } from '../constants';
import { IAcademicYearForm, ITermForm } from '../interface/academicYear.interface';

export enum ACADEMIC_YEAR_STATUS_OPTIONS {
  UPCOMING = 'UPCOMING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  COMPLETED = 'COMPLETED',
}

export enum RE_ENROLLMENT_CYCLE_STATUS {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  CLOSED = 'CLOSED',
}

export const STATUS_OPTIONS = [
  { label: ACADEMIC_YEAR_STATUS_OPTIONS.ACTIVE, value: ACADEMIC_YEAR_STATUS_OPTIONS.ACTIVE },
  { label: ACADEMIC_YEAR_STATUS_OPTIONS.INACTIVE, value: ACADEMIC_YEAR_STATUS_OPTIONS.INACTIVE },
  { label: ACADEMIC_YEAR_STATUS_OPTIONS.COMPLETED, value: ACADEMIC_YEAR_STATUS_OPTIONS.COMPLETED },
  { label: ACADEMIC_YEAR_STATUS_OPTIONS.UPCOMING, value: ACADEMIC_YEAR_STATUS_OPTIONS.UPCOMING },
];

export const ACADEMIC_YEAR_FORM_INIT: IAcademicYearForm = {
  name: {
    value: '',
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  curriculum: {
    value: null,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  startDate: {
    value: null,
    isRequired: false,
    error: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    disable: true,
  },
  endDate: {
    value: null,
    isRequired: false,
    error: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    disable: true,
  },
  status: {
    value: ACADEMIC_YEAR_STATUS_OPTIONS.UPCOMING,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
};

export const TERM_INIT: ITermForm = {
  id: {
    value: null,
    isRequired: false,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  name: {
    value: '',
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  startDate: {
    value: null,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    disable: false,
  },
  endDate: {
    value: null,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    disable: false,
  },
};
